<template>
<div>
<ProfileRegister/>

</div>
</template>
<script>
import ProfileRegister from "../components/ProfileRegister.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   ProfileRegister
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>